type PositionJsxOverCanvasProps = {
  fabricObject: fabric.Object;
  element: HTMLElement;
};

/**
 * Returns the offset between fabric's canvas wrapper and the JSX element's
 * offsetParent. Non-zero on S&S inside-right mobile where a 0.9x canvas
 * shrink triggers a `margin: 0 auto` on `.canvas-container` inside a wider
 * `.canvas-wrapper`. Returns (0,0) in all other cases. (PRCM-10837)
 */
const getCanvasOffsetWithinOverlayParent = (
  fabricObject: fabric.Object,
  element: HTMLElement,
): { offsetLeft: number; offsetTop: number } => {
  const overlayParent = element.offsetParent as HTMLElement | null;
  const canvasWrapperEl = (fabricObject.canvas as (fabric.Canvas & { wrapperEl?: HTMLElement }) | undefined)?.wrapperEl;
  if (!overlayParent || !canvasWrapperEl) {
    return { offsetLeft: 0, offsetTop: 0 };
  }
  const canvasRect = canvasWrapperEl.getBoundingClientRect();
  const parentRect = overlayParent.getBoundingClientRect();
  return {
    offsetLeft: canvasRect.left - parentRect.left,
    offsetTop: canvasRect.top - parentRect.top,
  };
};

export const positionJsxOverFabric = async ({ fabricObject, element }: PositionJsxOverCanvasProps) => {
  if (!element) {
    throw new Error('Canvas or element reference are not defined');
  }

  const boundingBox = fabricObject.getBoundingRect();
  const { top, left, height, width } = boundingBox;

  const { offsetLeft, offsetTop } = getCanvasOffsetWithinOverlayParent(fabricObject, element);

  element.style.left = `${left + offsetLeft}px`;
  element.style.top = `${top + offsetTop}px`;
  element.style.width = `${width}px`;
  element.style.height = `${height}px`;

  return { element };
};
